import { render } from "./dashboardClientComponent.vue?vue&type=template&id=3f0a725d"
import script from "./dashboardClientComponent.vue?vue&type=script&lang=js"
export * from "./dashboardClientComponent.vue?vue&type=script&lang=js"

import "./dashboardClientComponent.vue?vue&type=style&index=0&id=3f0a725d&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__